module.exports = __webpack_public_path__ + "img/anjoman_s.db866b3.svg";